import { styled } from "@mui/system";

export const InfoBox = styled("div")`
  margin: 0 auto;
  max-width: 332px;
  width: 100%;
  border-radius: 0.2rem;
  border: 0.075rem solid ${({ theme }) => theme.palette.border.main};
  background-color: ${({ theme }) => theme.palette.white.main};
`;

export const InfoBoxHeader = styled("div")`
  display: flex;
  align-items: center;
  padding: 1.2rem 1.6rem;
  min-height: 40px;
  background-color: ${({ theme }) => theme.palette.background.mediumDark};
  font-size: 1.3rem;
  line-height: 1.523rem;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.text.dark};
`;

export const InfoBoxContent = styled("div")`
  padding: 2.4rem 1.5rem;
`;

export const InfoBoxParagraph = styled("div")`
  padding-bottom: 0.8rem;
`;
